module.exports = __webpack_public_path__ + "static/media/home2.ecfd9594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/home/carousel-gallery/images/home2.jpg
// module id = 647
// module chunks = 0